// import firebase from 'firebase/app'
// import 'firebase/firestore'

// // Get a Firestore instance
// export const db = firebase
//   // .initializeApp({ projectId: 'MY PROJECT ID' })
//   .initializeApp({
//     apiKey: "AIzaSyCvQEwP5Kp5iBb78AvdjwHe5wfG2ruOvbA",
//     authDomain: "deknerd-556e6.firebaseapp.com",
//     databaseURL: "https://deknerd-556e6.firebaseio.com",
//     projectId: "deknerd-556e6",
//     storageBucket: "deknerd-556e6.appspot.com",
//     messagingSenderId: "434518633712",
//     appId: "1:434518633712:web:d564d8f1be8efe1014a635"
//   })
//   .firestore()

// // Export types that exists in Firestore
// // This is not always necessary, but it's used in other examples
// const { Timestamp, GeoPoint } = firebase.firestore
// export { Timestamp, GeoPoint }

// // if using Firebase JS SDK < 5.8.0
// db.settings({ timestampsInSnapshots: true })

import * as firebase from 'firebase'
var config = {
  apiKey: "AIzaSyCvQEwP5Kp5iBb78AvdjwHe5wfG2ruOvbA",
  authDomain: "deknerd-556e6.firebaseapp.com",
  databaseURL: "https://deknerd-556e6.firebaseio.com",
  projectId: "deknerd-556e6",
  storageBucket: "deknerd-556e6.appspot.com",
  messagingSenderId: "434518633712",
  appId: "1:434518633712:web:d564d8f1be8efe1014a635",
};
firebase.initializeApp(config)
// var database = firebase.database()
export default firebase